// Full-document render of the sealy GenericPage: PageSkeleton (the React
// document shell) wrapping the existing generic-page body assembly (which
// reproduces the per-block w-block-* wrappers). The legacy template rendered
// the body in {% block layout %} -- adjacent to content inside <main>, so the
// document DOM matches the content-block pages.
import React from "react";

import { templates } from "@reactivated";

import { GenericPageBody } from "../components/GenericPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.GenericPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <GenericPageBody page={props.page} />
    </PageSkeleton>
);
